// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__xze4_","container":"styles_container__1iiKy","message":"styles_message__ACkns","closeButton":"styles_closeButton__bW_E8"};